//常量
export default {
    storeKeys: {
        CLICKMENU: "CLICKMENU", //点击过的菜单
        EDEITFORM: "EDEITFORM", //编辑
        ADDFORM: 'ADDFORM', //添加
        FORMINFO: 'FORMINFO', //详情
        OTHERFORM: 'OTHERFORM',
        CURRENTFORM: 'CURRENTFORM', //添加，编辑当前from对象
        NEWESTROUTE: 'NEWESTROUTE', //最新路由
        SETFORMDATA: 'SETFORMDATA' //为当前form赋值
    },
    localStorageKeys: {
        pageSize: 'PAGESIZE'
    },
    buttonType: {
        searchAfter: 10, //放在搜索栏后面
        tableOperate: 20 //放在表格操作栏里
    },
    fileType: {
        video: { text: 'in', value: 'video', format: ['mp4'] },
        image: { text: '图片', value: 'image', format: ['png', 'jpg','jpeg'] },
        voice: { text: '音频', value: 'voice', format: ['mp3'] },
        file: { text: '文件', value: 'file' }
    },
    columnType: {
        input: 'input', // 输入框
        textarea: 'textarea', // 文本域
        select: 'select', // 下拉框
        radio: 'radio', // 单选按钮
        checkbox: 'checkbox', // 多选按钮
        checkboxNew:'checkboxNew',
        inputNumber: 'inputNumber', // 数字输入框
        cascader: 'cascader', // 级联选择器
        cascaderMultiple:'cascaderMultiple',// 多选级联选择器
        switch: 'switch', // 开关
        slider: 'slider', // 滑块
        timeSelect: 'timeSelect', // 时间选择器，开始时间，结束时间，时间间隔
        datePicker: 'datePicker', // 日期选择器
        dateMonthPicker:'dateMonthPicker',//月份选择器
        dateTimePicker: 'dateTimePicker', //日期时间选择器
        uploadFile: 'uploadFile', // 文件上传
        transfer: 'transfer', // 穿梭框
        password: 'password',
        repassword: 'repassword',
        attributeEditor: 'attributeEditor',
        casaderSelect: 'casaderSelect',
        slot: 'slot',
        verify: 'verify', //验证码
        richText: 'richText', //富文本
        code: 'code', //自动生成编码
        map: 'map', // 地图
        checkList: 'checkList', //多选按钮组
        numberRange: 'numberRange', //数字区间
        datetimeRange: 'datetimeRange',
        dateTimeRangeButton: 'dateTimeRangeButton',
        dateTimeRangeSearch: 'dateTimeRangeSearch',
        identitySelect:'identitySelect',
    },
}



// WEBPACK FOOTER //
// ./src/utils/constant.js